import React, { useRef, useState } from 'react'
import '../../assets/css/App.css'
import { useLocation, useNavigate } from 'react-router-dom'
import '../../assets/css/DairitenConfirmPage.css'
import { Prefex, appartments, birth1, city, day1, detail, kanjiName, kannaName, main, month1, names, phoneNo, recuriter, sales, town, year1, zip1, zip2 } from '../../utils/DairitenText'
import { CDP_PUBLIC_URL, REACT_APP_SITE_KEY } from '../../utils/Constants'
import ReCAPTCHA from 'react-google-recaptcha'
import { callSaveAPI } from '../../api/CDPAPI'
import { useIntl } from 'react-intl'

const DairitenConfirmPage = () => {
    document.title = 'お問い合わせ／エントリー｜メットライフ生命'
    const location = useLocation()
    const data = location.state
    const submitData = JSON.parse(JSON.stringify(data))
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const intl = useIntl()
    const captchaRef = useRef(null)
    const recapture = async (e) => {
        const token = await captchaRef.current.executeAsync()
        await callSaveAPI('dairiten-submit', { ...submitData, recaptchaToken: token })
        .then(res => {
            if (res.status === 200) {
                setLoading(false)
                captchaRef.current.reset()
                navigate(`${CDP_PUBLIC_URL}/agency/complete`, { state: data })
            } else {
                if (window.confirm(intl.formatMessage({ id: 'submissionError' }))) {
                    navigate(`${CDP_PUBLIC_URL}/agency`, { state: data })
                } else {
                    setLoading(false)
                }
            }
          }).catch(() => {
            if (window.confirm(intl.formatMessage({ id: 'submissionError' }))) {
                navigate(`${CDP_PUBLIC_URL}/agency`, { state: data })
            } else {
                setLoading(false)
            }
          })
    }
    const handleSubmit = async (e) => {
        window.scrollTo(0, document.body.scrollHeight)
        e.preventDefault()
        // prefecture no write API bug, append into address1
        if (submitData.pref !== '都道府県') {
            submitData.address1 = submitData.pref + submitData.address1
        }
        recapture()
    }
    const handleBack = () => {
        navigate(`${CDP_PUBLIC_URL}/agency`, { state: data })
    }
    return (
        <div className="dairiten-input-section-inputdetails">
            <div className="">
            <div id="headerFrame12">
            </div>
            </div>
            <div className="">
                <h1 id="h1">お問い合わせ／エントリー<br></br></h1>
                <h2 id="h2">エントリー確認</h2>
                <p>登録内容の確認をお願いいたします。</p>
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">基本情報</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{names}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.agencyName}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{kanjiName}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.kanjiName}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{kannaName}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.kanaName}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{birth1}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.calendarType}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{year1}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.birthYear}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{month1}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.birthMonth}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{day1}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.birthDate}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{main}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.occupation.join(', ')}
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">ご住所・お電話番号</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{zip1}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.zipCode1}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{zip2}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.zipCode2}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{Prefex}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.pref}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{city}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.address1}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{town}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.address2}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{appartments}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.address3}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{phoneNo}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.telephone}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">E-mail</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.email}
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="card-container-inputdetails">
                    <div className="row">
                        <span id="span1">基本情報</span>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{sales}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.experienceOfSellingInsurance}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{recuriter}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.registrationHistory}
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 titleDiv">
                        <label htmlFor="inputtext" className="col-form-label l1">{detail}</label>
                        </div>
                        <div className="col-lg-9 col-md-9 col-sm-12 col-12 contentDiv">
                        {data.remarks}
                        </div>
                    </div>
                </div>
            </div>
            {loading
                ? <div className='spinContainer'>
                      <div className='spin'></div>
                      <span><h2>{intl.formatMessage({ id: 'LoadingMsg' })}</h2></span>
                    </div>
                : <><div className="card-container-inputdetails row">
                        <p className="form-btn-01"><input type="submit" value="送信" name="submit" className="btn-submit" onClick={handleSubmit} /></p>
                    </div>
                    <div className="card-container-inputdetails row">
                        <p className="form-btn-01"><input type="submit" value="訂正" name="submit" className="btn-submit1" onClick={handleBack}/></p>
                    </div></>
            }
            <ReCAPTCHA sitekey={REACT_APP_SITE_KEY} size='invisible' ref={captchaRef} />
        </div>
    )
}

export default DairitenConfirmPage
